import React from 'react';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../../constants/ActionTypes';

const cardDataStoreDefaults = {
    title: {
        font: 'IBM Plex sans',
        color: '#000000',
        size: '24px',
        weight: 'normal',
        style: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left'
    },
    subtitle: {
        font: 'IBM Plex sans',
        color: '#000000',
        size: '16px',
        weight: 'normal',
        style: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left'
    },
    defaultLink: {
        font: 'IBM Plex sans',
        color: '#23826F',
        size: '16px',
        weight: 'bold',
        style: 'normal',
        decoration: 'underline',
        lineHeight: '1.0',
        align: 'left'
    },
    inlineLink: {
        font: 'IBM Plex sans',
        color: '#000000',
        size: '24px',
        weight: 'normal',
        style: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left'
    },
    description: {
        font: 'IBM Plex sans',
        color: '#000000',
        size: '24px',
        weight: 'normal',
        style: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left'
    },
    largePrice: {
        font: 'IBM Plex Sans',
        color: '#23826F',
        size: '24px',
        weight: 'normal',
        style: 'normal',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'center'
    }
};

const cardDataReducer = handleActions(
    {
        [ActionTypes.THEME_CARD_SET_THEME_FONT]: (state, action) => {
            let obj = {
                card: {
                    ...state.card
                }
            };
            if (action.layer === 'defaultLink') {
                obj['card']['link'] = { ...state['card']['link'], font: action.font };
            } else {
                obj['card'][action.layer] = { ...state['card'][action.layer], font: action.font };
            }
            obj[action.layer] = { ...state[action.layer], font: action.font };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CARD_SET_THEME_FONT_SIZE]: (state, action) => {
            let obj = {
                card: {
                    ...state.card
                }
            };
            if (action.layer === 'defaultLink') {
                obj['card']['link'] = { ...state['card']['link'], size: action.size };
            } else {
                obj['card'][action.layer] = { ...state['card'][action.layer], size: action.size };
            }
            obj[action.layer] = { ...state[action.layer], size: action.size };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CARD_SET_THEME_FONT_WEIGHT]: (state, action) => {
            let obj = {
                card: {
                    ...state.card
                }
            };
            if (action.layer === 'defaultLink') {
                obj['card']['link'] = { ...state['card']['link'], weight: action.weight };
            } else {
                obj['card'][action.layer] = { ...state['card'][action.layer], weight: action.weight };
            }
            obj[action.layer] = { ...state[action.layer], weight: action.weight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CARD_SET_THEME_FONT_COLOR]: (state, action) => {
            let obj = {
                card: {
                    ...state.card
                }
            };
            if (action.layer === 'defaultLink') {
                obj['card']['link'] = { ...state['card']['link'], color: action.color };
            } else {
                obj['card'][action.layer] = { ...state['card'][action.layer], color: action.color };
            }
            obj[action.layer] = { ...state[action.layer], color: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CARD_SET_THEME_FONT_STYLE]: (state, action) => {
            let obj = {
                card: {
                    ...state.card
                }
            };
            if (action.layer === 'defaultLink') {
                obj['card']['link'] = { ...state['card']['link'], style: action.style };
            } else {
                obj['card'][action.layer] = { ...state['card'][action.layer], style: action.style };
            }
            obj[action.layer] = { ...state[action.layer], style: action.style };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CARD_SET_THEME_TEXT_ALIGN]: (state, action) => {
            let obj = {
                card: {
                    ...state.card
                }
            };
            if (action.layer === 'defaultLink') {
                obj['card']['link'] = { ...state['card']['link'], textAlign: action.textAlign };
            } else {
                obj['card'][action.layer] = { ...state['card'][action.layer], textAlign: action.textAlign };
            }
            obj[action.layer] = { ...state[action.layer], textAlign: action.textAlign };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CARD_SET_THEME_TEXT_DECORATION]: (state, action) => {
            let obj = {
                card: {
                    ...state.card
                }
            };
            if (action.layer === 'defaultLink') {
                obj['card']['link'] = { ...state['card']['link'], decoration: action.decoration };
            } else {
                obj['card'][action.layer] = { ...state['card'][action.layer], decoration: action.decoration };
            }
            obj[action.layer] = { ...state[action.layer], decoration: action.decoration };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_CARD_SET_THEME_LINE_HEIGHT]: (state, action) => {
            let obj = {
                card: {
                    ...state.card
                }
            };
            if (action.layer === 'defaultLink') {
                obj['card']['link'] = { ...state['card']['link'], lineHeight: action.lineHeight };
            } else {
                obj['card'][action.layer] = { ...state['card'][action.layer], lineHeight: action.lineHeight };
            }
            obj[action.layer] = { ...state[action.layer], lineHeight: action.lineHeight };
            return { ...state, ...obj };
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('card')) {
                return { ...state, card: action.theme.card };
            } else {
                return state;
            }
        }
    },
    cardDataStoreDefaults
);

export default cardDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/card.js